import {HttpServices} from "../Helpers";

export const GetFeedbackDetails = async ({
  user_uuid,
  candidate_uuid,
  job_uuid,
}) => {
  return await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/recruiter/ats/${process.env.REACT_APP_VERSION_API_V2}/candidate/feedback`,
    {
      params: {
        user_uuid,
        candidate_uuid,
        job_uuid,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const CreateCandidateFeedback = async (body) => {
  return await HttpServices.put(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/recruiter/ats/${process.env.REACT_APP_VERSION_API_V2}/candidate/feedback`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const UpdateCandidateFeedback = async (body) => {
  return await HttpServices.put(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/recruiter/ats/${process.env.REACT_APP_VERSION_API_V2}/candidate/feedback`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const DeleteCandidateFeedback = async (params) => {
  return await HttpServices.delete(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/recruiter/ats/${process.env.REACT_APP_VERSION_API_V2}/candidate/feedback`,
    {
      params,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const GetInitialApprovalFeedbackDetails = async ({share_uuid}) => {
  return await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/${process.env.REACT_APP_VERSION_API}/pre-approval/candidate/share`,
    {
      params: {
        share_uuid,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const UpdateInitialApprovalCandidateFeedback = async (body) => {
  return await HttpServices.put(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/${process.env.REACT_APP_VERSION_API}/pre-approval/candidate/share`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const DeleteInitialApprovalCandidateFeedback = async (params) => {
  return await HttpServices.delete(
    `${process.env.REACT_APP_DOMIN_PHP_API}/api/${process.env.REACT_APP_VERSION_API}/pre-approval/candidate/share`,
    {
      params,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
};

export const GetAssessmentFeedbackDetails = async ({
  candidate_uuid,
  user_uuid,
  assessment_uuid,
}) => {
  return await HttpServices.get(
    `${process.env.REACT_APP_DOMIN_PHP_API_GET}/api/recruiter/ats/${process.env.REACT_APP_VERSION_API_V2}/candidate/feedback`,
    {
      params: {
        candidate_uuid,
        user_uuid,
        assessment_uuid,
      },
    }
  )
    .then((data) => data)
    .catch((error) => error.response);
};
